/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 16:33:25
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-21 10:56:16
 * @FilePath: \crm-product\src\views\performanceCalculation\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const subRouters = [
  {
    path: '/performance_calculation',
    name: 'performance_calculation',
    meta: {
      title: '业绩计算',
    },
    component: { render: (e) => e('router-view') },
    children: [
      {
        path: 'product_price',
        name: 'product_price',
        component: () => import(
          /* webpackChunkName: "import_statement/product_price" */ '../views/import_statement/product_price/table'
        ),
        meta: { title: '产品价格/价格带系数表' },
      },
      {
        path: 'performance_target',
        name: 'performance_target',
        component: () => import(
          /* webpackChunkName: "import_statement/performance_target" */ '../views/import_statement/performance_target/table'
        ),
        meta: { title: '业绩目标' },
      },
      {
        path: 'terminal_performance_import',
        name: 'terminal_performance_import',
        component: () => import(
          /* webpackChunkName: "import_statement/terminal_performance_import" */ '../views/import_statement/terminal_performance_import/table'
        ),
        meta: { title: '终端动销业绩数据导入' },
      },
      {
        path: 'network_performance_import',
        name: 'network_performance_import',
        component: () => import(
          /* webpackChunkName: "import_statement/network_performance_import" */ '../views/import_statement/network_performance_import/table'
        ),
        meta: { title: '新增网点业绩数据导入' },
      },
      {
        path: 'dealer_performance_import',
        name: 'dealer_performance_import',
        component: () => import(
          /* webpackChunkName: "import_statement/dealer_performance_import" */ '../views/import_statement/dealer_performance_import/table'
        ),
        meta: { title: '直营店业绩数据导入' },
      },
      {
        path: 'personnel_hierarchy',
        name: 'personnel_hierarchy',
        component: () => import(
          /* webpackChunkName: "import_statement/personnel_hierarchy" */ '../views/import_statement/personnel_hierarchy/table'
        ),
        meta: { title: '人员上下级' },
      },
      {
        path: 'personnel_dealer_terminal',
        name: 'personnel_dealer_terminal',
        component: () => import(
          /* webpackChunkName: "import_statement/personnel_dealer_terminal" */ '../views/import_statement/personnel_dealer_terminal/table'
        ),
        meta: { title: '人员与经销商/终端' },
      },
      {
        path: 'terminal_performance_target',
        name: 'terminal_performance_target',
        component: () => import(
          /* webpackChunkName: "import_statement/terminal_performance_target" */ '../views/import_statement/terminal_performance_target/table'
        ),
        meta: { title: '核心终端目标' },
      },
      {
        path: 'personal_target',
        name: 'personal_target',
        component: () => import(
          /* webpackChunkName: "import_statement/personal_target" */ '../views/import_statement/personal_target/table'
        ),
        meta: { title: '人员个性化业绩目标' },
      },

      {
        path: 'monthly_performance_report',
        name: 'monthly_performance_report',
        component: () => import(
          /* webpackChunkName: "result_statement/monthly_performance_report" */ '../views/result_statement/monthly_performance_report/table'
        ),
        meta: { title: '月度业绩报表' },
      },
      {
        path: 'annual_performance_report',
        name: 'annual_performance_report',
        component: () => import(
          /* webpackChunkName: "result_statement/annual_performance_report" */ '../views/result_statement/annual_performance_report/table'
        ),
        meta: { title: '年度业绩报表' },
      },
      {
        path: 'monthly_network_performance_report',
        name: 'monthly_network_performance_report',
        component: () => import(
          /* webpackChunkName: "result_statement/monthly_network_performance_report" */ '../views/result_statement/monthly_network_performance_report/table'
        ),
        meta: { title: '月度新增网点业绩报表' },
      },
      {
        path: 'annual_network_performance_report',
        name: 'annual_network_performance_report',
        component: () => import(
          /* webpackChunkName: "result_statement/annual_network_performance_report" */ '../views/result_statement/annual_network_performance_report/table'
        ),
        meta: { title: '年度新增网点业绩报表' },
      },
      {
        path: 'monthly_terminal_performance_report',
        name: 'monthly_terminal_performance_report',
        component: () => import(
          /* webpackChunkName: "result_statement/monthly_terminal_performance_report" */ '../views/result_statement/monthly_terminal_performance_report/table'
        ),
        meta: { title: '月度终端动销业绩报表' },
      },
      {
        path: 'annual_terminal_performance_report',
        name: 'annual_terminal_performance_report',
        component: () => import(
          /* webpackChunkName: "result_statement/annual_terminal_performance_report" */ '../views/result_statement/annual_terminal_performance_report/table'
        ),
        meta: { title: '年度终端动销业绩报表' },
      },
      {
        path: 'terminal_performance_target_report',
        name: 'terminal_performance_target_report',
        component: () => import(
          /* webpackChunkName: "result_statement/terminal_performance_target_report" */ '../views/result_statement/terminal_performance_target_report/table'
        ),
        meta: { title: '核心网点建设汇总报表' },
      },
      {
        path: 'dealer_performance_report',
        name: 'dealer_performance_report',
        component: () => import(
          /* webpackChunkName: "result_statement/dealer_performance_report" */ '../views/result_statement/dealer_performance_report/table'
        ),
        meta: { title: '直营店业绩报表' },
      },
      {
        path: 'personalized_indicator',
        name: 'personalized_indicator',
        component: () => import(
          /* webpackChunkName: "result_statement/personalized_indicator" */ '../views/result_statement/personalized_indicator/table'
        ),
        meta: { title: '个性化指标报表' },
      },
    ],
  },
];

export default subRouters;
